import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import moment from 'moment';
import ActivitiesService from '../services/ActivitiesService';

function mapTimelineSteps(data) {
  // Group by date: Sum the entries at the same date range interval
  var dataByDate = data.reduce(function (acc, item) {
    var actualDate = item.date,
        value = item.value;
    var dateRangeItemFormat = 'YYYY-MM-DD'; // group day by day

    var date = moment(actualDate).format(dateRangeItemFormat);
    acc[date] = (acc[date] || 0) + value;
    return acc;
  }, {});
  return Object.keys(dataByDate).map(function (date) {
    return {
      date: date,
      value: dataByDate[date]
    };
  });
}

export default function getTimelineSteps(_x, _x2) {
  return _getTimelineSteps.apply(this, arguments);
}

function _getTimelineSteps() {
  _getTimelineSteps = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(startDate, endDate) {
    var activitiesService, params, activities, timelineData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            activitiesService = new ActivitiesService();
            params = [{
              date: "ge".concat(moment(startDate).hour(0).minute(0).second(0).utc().toISOString())
            }, {
              date: "le".concat(moment(endDate).hour(23).minute(59).second(59).utc().toISOString())
            }, {
              _sort: '-date',
              _count: 100000,
              // TODO: any way to unlimit in fhir?
              _elements: 'effectivePeriod,component'
            }];
            _context.next = 4;
            return activitiesService.fetchData(params);

          case 4:
            activities = _context.sent;
            timelineData = [];
            activities.forEach(function (activity) {
              if (!activity.datePeriod || !activity.datePeriod.start || !activity.steps) {
                return;
              }

              timelineData.push({
                date: activity.datePeriod.start,
                value: activity.steps
              });
            });
            return _context.abrupt("return", mapTimelineSteps(timelineData));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getTimelineSteps.apply(this, arguments);
}

;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(mapTimelineSteps, "mapTimelineSteps", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/timelineData/getTimelineSteps.js");
  reactHotLoader.register(getTimelineSteps, "getTimelineSteps", "/home/runner/html/nextcloud/apps/ehr/js/plugins/activities/src/timelineData/getTimelineSteps.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();